export const FIRST_NAME_FIELD_ID = 'firstName';
export const LAST_NAME_FIELD_ID = 'lastName';
export const EMAIL_FIELD_ID = 'email';

export const REQUIRED_FIELDS_FOR_LEAD = [FIRST_NAME_FIELD_ID, LAST_NAME_FIELD_ID, EMAIL_FIELD_ID];

/**
 * function that receives the current values and errors in the form
 * and return a function that receives the field id and return a boolean
 * indicating if the field is valid in the form (has a value and no error)
 *
 * @param {object} formValues
 * @param {object} formSyncErrors
 */
const isFieldValidInForm = (formValues, formSyncErrors) => fieldId =>
  formValues[fieldId] && !formSyncErrors[fieldId];

/**
 * function that receives the current values and errors in the form
 * and return if all fields indicated by REQUIRED_FIELDS_FOR_LEAD are valid
 * acorrding to the function isFieldValidInForm
 */
export const canCreateLead = (currentValues, formSyncErrors) => {
  const fieldValidator = isFieldValidInForm(currentValues, formSyncErrors);
  return REQUIRED_FIELDS_FOR_LEAD.every(fieldValidator);
};
